import { statutPrecarite } from 'types/Concessionnaire';

const DECILE_THRESHOLDS = [
  1970, 7640, 11250, 14130, 16880, 19600, 22770, 27310, 35880,
] as const;

export function getDecile(
  revenuFiscalReference?: number,
  nombreParts?: number,
) {
  if (
    revenuFiscalReference === undefined ||
    nombreParts === undefined ||
    nombreParts <= 0
  ) {
    return undefined;
  }

  const revenuParPart = revenuFiscalReference / nombreParts;
  const thresholdIndex = DECILE_THRESHOLDS.findIndex(
    (threshold) => revenuParPart <= threshold,
  );

  return thresholdIndex === -1 ? 10 : thresholdIndex + 1;
}

export function getStatutPrecariteFromDecile(decile?: number) {
  if (!decile) {
    return undefined;
  }

  if (decile <= 3) {
    return statutPrecarite.PRECAIRE;
  }

  if (decile <= 5) {
    return statutPrecarite.MODESTE;
  }

  return statutPrecarite.CLASSIQUE;
}
